import { LessonHomeworkIndexView } from './lesson_homeworks';
import { ISODateTime } from '../../commonv3/types/dates';
import { SimpleUserView } from './users';
import { ReviewerIndexView } from './reviewers';
import { ExamPracticalSectionShowView } from './exam_sections';

export type CourseWorkSubmissionToken = string;
export enum CourseWorkSubmissionTargetType {
  LESSON_HOMEWORK_SUBMISSION = 'Online::LessonHomeworkSubmission',
  EXAM_PRACTICAL_SECTION_SUBMISSION = 'Online::PracticalSectionSubmission',
}

export type CourseWorkSubmissionBaseView = {
  id: number;
  token: CourseWorkSubmissionToken;
  user: SimpleUserView;
  review_deadline: ISODateTime;
  remaining_review_days: number;
  reviewer: ReviewerIndexView;
  review_completed_at: ISODateTime | null;
  alert_target: boolean;
  created_at: ISODateTime;
  updated_at: ISODateTime;
  unconfirmed_user_comment_count: number;
};

export type CourseWorkSubmissionIndexView = CourseWorkSubmissionBaseView &
  (
    | {
        course_work_submission_type: CourseWorkSubmissionTargetType.LESSON_HOMEWORK;
        course_work: LessonHomeworkIndexView;
      }
    | {
        course_work_submission_type: CourseWorkSubmissionTargetType.EXAM_PRACTICAL_SECTION;
        course_work: ExamPracticalSectionShowView;
      }
  );
